import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

 @Component({
    imports: [FormsModule, ReactiveFormsModule, SharedModule, RouterModule, MatIconModule, MatButtonModule, NgSelectModule, BsDatepickerModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-addassessor',
    templateUrl: './addassessor.component.html',
    styleUrls: ['./addassessor.component.css']
})
export class AddassessorComponent implements OnInit {
  dropdownList = [{Id:'1',Name:'Andhra Pradesh'},
  {Id:'2',Name:'Bihar'},
  {Id:'3',Name:'Chattisgarh'},
  {Id:'4',Name:'Delhi'},
  {Id:'5',Name:'Goa'},
  {Id:'6',Name:'Himachal Pradesh'},
  {Id:'7',Name:'Jharkhand'},
  {Id:'8',Name:'Karnataka'}
];
  selectedItems='0';

  constructor() { }

  ngOnInit(): void {
  }

}
